export class AwsKeyspacesResource {
    'keyspaceName';
    'tableName';
    'cdcStatus';
    'cdcViewType';
    'billingMode';
    'readCapacityUnits';
    'writeCapacityUnits';
    'replicaRegions';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "keyspaceName",
            "baseName": "keyspaceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "cdcStatus",
            "baseName": "cdcStatus",
            "type": "AwsKeyspacesResourceCdcStatusEnum",
            "format": ""
        },
        {
            "name": "cdcViewType",
            "baseName": "cdcViewType",
            "type": "AwsKeyspacesResourceCdcViewTypeEnum",
            "format": ""
        },
        {
            "name": "billingMode",
            "baseName": "billingMode",
            "type": "DynamoDbBillingMode",
            "format": ""
        },
        {
            "name": "readCapacityUnits",
            "baseName": "readCapacityUnits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "writeCapacityUnits",
            "baseName": "writeCapacityUnits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "replicaRegions",
            "baseName": "replicaRegions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsKeyspacesResource.attributeTypeMap;
    }
    constructor() {
    }
}
export var AwsKeyspacesResourceCdcStatusEnum;
(function (AwsKeyspacesResourceCdcStatusEnum) {
    AwsKeyspacesResourceCdcStatusEnum["Enabled"] = "CDC_ENABLED";
    AwsKeyspacesResourceCdcStatusEnum["Disabled"] = "CDC_DISABLED";
    AwsKeyspacesResourceCdcStatusEnum["Enabling"] = "CDC_ENABLING";
    AwsKeyspacesResourceCdcStatusEnum["Disabling"] = "CDC_DISABLING";
})(AwsKeyspacesResourceCdcStatusEnum || (AwsKeyspacesResourceCdcStatusEnum = {}));
export var AwsKeyspacesResourceCdcViewTypeEnum;
(function (AwsKeyspacesResourceCdcViewTypeEnum) {
    AwsKeyspacesResourceCdcViewTypeEnum["NewImage"] = "NEW_IMAGE";
    AwsKeyspacesResourceCdcViewTypeEnum["OldImage"] = "OLD_IMAGE";
    AwsKeyspacesResourceCdcViewTypeEnum["KeysOnly"] = "KEYS_ONLY";
    AwsKeyspacesResourceCdcViewTypeEnum["NewAndOldImages"] = "NEW_AND_OLD_IMAGES";
})(AwsKeyspacesResourceCdcViewTypeEnum || (AwsKeyspacesResourceCdcViewTypeEnum = {}));
